/**
 * Metadata dùng chung cho "ứng dụng" (project): trạng thái, nền tảng, giới hạn.
 * Admin form và trang giới thiệu đều dựa trên các hằng số này.
 */

export const MAX_IMAGES = 6;
export const MAX_FEATURES = 12;

export const APP_STATUS = {
    live: {
        value: 'live',
        label: 'Đang hoạt động',
        badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300',
        dot: 'bg-emerald-500',
    },
    beta: {
        value: 'beta',
        label: 'Thử nghiệm',
        badge: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-300',
        dot: 'bg-amber-500',
    },
    wip: {
        value: 'wip',
        label: 'Đang phát triển',
        badge: 'bg-sky-100 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300',
        dot: 'bg-sky-500',
    },
    archived: {
        value: 'archived',
        label: 'Ngừng cập nhật',
        badge: 'bg-slate-200 text-slate-600 dark:bg-white/10 dark:text-slate-400',
        dot: 'bg-slate-400',
    },
};

export const APP_STATUS_OPTIONS = Object.values(APP_STATUS);

export const DEFAULT_STATUS = APP_STATUS.live.value;

export const getStatusMeta = (status) => APP_STATUS[status] || APP_STATUS.live;

export const PLATFORM_OPTIONS = ['Web', 'macOS', 'iOS', 'Android', 'CLI', 'Desktop', 'Khác'];

/**
 * Danh mục cố tình để ít.
 * Với ~20 ứng dụng, mười danh mục nghĩa là phần lớn bộ lọc chỉ ra một kết quả —
 * lúc đó nó không còn là bộ lọc nữa. Năm nhóm, mỗi nhóm ít nhất hai app.
 */
export const CATEGORY_SUGGESTIONS = [
    'Tiện ích',
    'Quản lý',
    'Game',
    'Ứng dụng macOS',
    'Cá nhân',
];

/** Các loại liên kết hiển thị ở trang giới thiệu. */
export const LINK_KINDS = [
    { key: 'externalUrl', label: 'Trang web / Demo', placeholder: 'https://app.buitientuan.com/' },
    { key: 'githubUrl', label: 'Mã nguồn GitHub', placeholder: 'https://github.com/TuanBT/...' },
    { key: 'downloadUrl', label: 'Tải về / Release', placeholder: 'https://github.com/.../releases/latest' },
    { key: 'videoUrl', label: 'Video giới thiệu', placeholder: 'https://youtube.com/watch?v=...' },
    { key: 'docsUrl', label: 'Tài liệu', placeholder: 'https://...' },
];
